/* L'Atelier de la Poêle · ticket à gratter (fenêtre de bienvenue) et connexion Klaviyo.
   Sorti du HTML le 13/10/2026 et chargé en defer : mis en cache d'une page à l'autre.
   Ouverture inchangée (10 s après l'arrivée) ; feuille, photo, logo et polices à 7 s. */
/* Connexion publique Klaviyo. Aucun secret ni adresse client n'est stocké. */
(() => {
  'use strict';
  const storageKey = 'atelier_ticket_10_until';
  const preview = new URLSearchParams(location.search).get('atelier_popup') === '1';
  function remember(days) {
    try { localStorage.setItem(storageKey, String(Math.max(Number(localStorage.getItem(storageKey)) || 0, Date.now() + days * 86400000))); } catch (_) {}
  }
  let dismissedUntil = 0;
  try { dismissedUntil = Number(localStorage.getItem(storageKey)) || 0; } catch (_) {}
  let pendingIdentity = null, identityJob = null, privacyJob = null;
  const identityState = state => {
    const root = document.getElementById('atl-popup');
    if (root) root.dataset.klaviyoIdentity = state;
  };
  function customerPrivacy() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!privacyJob) privacyJob = new Promise(resolve => {
      if (!window.Shopify?.loadFeatures) { resolve(null); return; }
      const timer = setTimeout(() => resolve(null), 3000);
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        clearTimeout(timer);resolve(error ? null : window.Shopify.customerPrivacy);
      });
    });
    return privacyJob;
  }
  async function identifyVisitor() {
    if (!pendingIdentity || identityJob) return identityJob;
    identityJob = (async () => {
      const privacy = await customerPrivacy();
      if (!privacy || !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) {
        identityState('awaiting-tracking-consent');
        return;
      }
      const email = pendingIdentity;
      identityState('pending');
      const deadline = Date.now() + 8000;
      while (typeof window.klaviyo?.identify !== 'function' && Date.now() < deadline) {
        await new Promise(resolve => setTimeout(resolve, 150));
      }
      if (typeof window.klaviyo?.identify !== 'function') {
        identityState('sdk-unavailable');return;
      }
      await new Promise(resolve => {
        let settled = false;
        const timer = setTimeout(() => { if (!settled) identityState('unconfirmed');resolve(); }, 4000);
        const complete = () => {
          settled = true;clearTimeout(timer);
          identityState('identified');
          document.dispatchEvent(new CustomEvent('atelier:klaviyo-identified'));
          if (pendingIdentity === email) pendingIdentity = null;
          resolve();
        };
        try {
          const request = window.klaviyo.identify({email}, complete);
          if (request?.catch) request.catch(() => {
            settled = true;clearTimeout(timer);identityState('unconfirmed');resolve();
          });
        } catch (_) {clearTimeout(timer);identityState('unconfirmed');resolve();}
      });
    })().catch(() => {identityState('unconfirmed');}).finally(() => {identityJob = null;});
    return identityJob;
  }
  document.addEventListener('visitorConsentCollected', () => {void identifyVisitor();});
  window.ATELIER_POPUP_CONFIG = {
    demo: false,
    code: 'BIENVENUE10',
    autoOpen: false,
    onClose: () => remember(7),
    onSuccess: () => remember(365),
    async subscribe({email, source, consentText}) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=XsBHhf', {
          method: 'POST',
          headers: {'Accept':'application/vnd.api+json','Content-Type':'application/vnd.api+json','revision':'2026-07-15'},
          signal: controller.signal,
          body: JSON.stringify({data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {data: {type: 'profile', attributes: {
                email,
                subscriptions: {email: {marketing: {consent:'SUBSCRIBED'}}},
                properties: {atelier_popup_source:source, atelier_popup_offer:'BIENVENUE10', atelier_popup_consent:consentText}
              }}}
            },
            relationships: {list: {data: {type:'list',id:'WPmqDb'}}}
          }})
        });
        if (response.status !== 202) {
          console.warn('[Atelier inscription] Réponse Klaviyo', response.status);
          throw new Error('SUBSCRIPTION_FAILED');
        }
        pendingIdentity = email;
        await Promise.race([identifyVisitor(), new Promise(resolve => setTimeout(resolve, 1500))]);
        return {status:'accepted',couponCode:'BIENVENUE10'};
      } finally { clearTimeout(timeout); }
    }
  };
  // Prépare le ticket : sa feuille, ses images et ses polices (13/10/2026). Appelée 3 s avant
  // l'ouverture. La promesse vaut true quand la feuille est appliquée ; les polices ont 1,5 s
  // de plus au plus, sinon le ticket s'ouvre avec les polices de secours.
  let preparing = null;
  function prepare() {
    if (preparing) return preparing;
    const popup = document.getElementById('atl-popup');
    if (!popup) return Promise.resolve(false);
    const sheet = new Promise(resolve => {
      const href = popup.dataset.atlCss;
      const existing = document.querySelector('link[data-atl-css]');
      if (!href) { resolve(true); return; }
      if (existing) { resolve(existing.sheet ? true : new Promise(r => { existing.addEventListener('load', () => r(true)); existing.addEventListener('error', () => r(false)); })); return; }
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = href; link.setAttribute('data-atl-css', '');
      link.onload = () => resolve(true); link.onerror = () => resolve(false);
      document.head.appendChild(link);
    });
    popup.querySelectorAll('img').forEach(img => {img.loading = 'eager';});
    const fonts = document.fonts?.load ? Promise.allSettled([
      document.fonts.load('800 32px AtelierPopupBarlow'),
      document.fonts.load('700 36px AtelierPopupFraunces'),
      document.fonts.load('italic 700 36px AtelierPopupFraunces')
    ]) : Promise.resolve();
    preparing = sheet.then(ok => Promise.race([fonts, new Promise(r => setTimeout(r, 1500))]).then(() => ok));
    return preparing;
  }
  window.atelierPopupPrepare = prepare;
  function schedule() {
    if (!preview && (dismissedUntil > Date.now() || document.documentElement.hasAttribute('data-design-mode'))) return;
    const popup = document.getElementById('atl-popup');
    if (!popup) return;
    let arrived = Date.now();
    if (!preview) {
      try {
        const key = 'atelier_ticket_visit_started';
        const previous = Number(sessionStorage.getItem(key));
        if (previous > 0 && arrived - previous < 1800000) arrived = previous;
        else sessionStorage.setItem(key, String(arrived));
      } catch (_) {}
    }
    // Les fichiers du ticket partent 3 s avant l'ouverture, jamais pendant l'affichage de la page
    // (13/10/2026). L'ouverture reste fixée à 10 s après l'arrivée sur le site.
    const prepTimer = setTimeout(prepare, Math.max(0, 7000 - (Date.now() - arrived)));
    const openWhenReady = () => {
      prepare().then(ready => { if (ready && popup.isConnected) window.atelierPopup?.open(); });
    };
    const timer = setTimeout(() => {
      if (!popup?.isConnected) return;
      if (document.hidden) {
        document.addEventListener('visibilitychange', function visible() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', visible);
          if (popup.isConnected) openWhenReady();
        });
      } else openWhenReady();
    }, Math.max(0, 10000 - (Date.now() - arrived)));
    window.addEventListener('pagehide', () => { clearTimeout(timer); clearTimeout(prepTimer); }, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
})();

/* L’Atelier · V3. Design du ticket repris de la référence fournie.
   Aucun appel Klaviyo en mode démonstration. */
(() => {
  'use strict';
  const cfg = Object.freeze({
    demo: true,
    code: 'BIENVENUE10',
    autoOpen: true,
    subscribe: null,
    ...(window.ATELIER_POPUP_CONFIG || {})
  });
  const root = document.getElementById('atl-popup');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = s => root.querySelector(s);
  const box = $('.atl__box'), panel = $('.atl__panel'), content = $('.atl__content');
  const steps = [...root.querySelectorAll('.atl__step')];
  const ticket = $('#atl-ticket'), prize = $('#atl-prize'), foil = $('#atl-foil');
  const ctx = foil.getContext('2d');
  const form = $('#atl-form'), input = $('#atl-email'), submit = $('#atl-submit');
  const submitLabel = submit.querySelector('[data-atl-label]');
  const errorEl = $('#atl-error'), codeEl = $('#atl-code'), claim = $('[data-atl-claim]');
  const hint = $('.atl__hint'), skip = $('[data-atl-reveal]'), live = $('[data-atl-live]');
  const scratchHeading = $('[data-atl-scratch-heading]'), rewardHeading = $('[data-atl-reward-heading]');
  const scratchCopy = $('[data-atl-scratch-copy]');
  const copyBtn = $('[data-atl-copy]');
  let W = 0, H = 0, dpr = 1, cols = 0, rows = 0, grid = null, marked = 0, total = 1;
  const CELL = 8, BRUSH = 24;
  let started = false, revealed = false, scratching = false, last = null, step = 1, opened = false;
  let lastFocus = null, activePointer = null, strokes = [], replaying = false;
  let submitting = false, generation = 0, copyTimer, closeTimer, openFrame, finishClose;
  let contentTransition = null;
  let scrollX = 0, scrollY = 0, savedBody = null, hadLock = false, isolated = [];
  codeEl.textContent = cfg.code;

  function noisePattern() {
    var n = document.createElement("canvas"); n.width = n.height = 96;
    var c = n.getContext("2d"), d = c.createImageData(96, 96), p = d.data;
    for (var i = 0; i < p.length; i += 4) { var v = 120 + Math.random() * 135; p[i] = p[i + 1] = p[i + 2] = v; p[i + 3] = 255; }
    c.putImageData(d, 0, 0);
    return ctx.createPattern(n, "repeat");
  }
  function roundRectPath(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function paintScratchMarks() {
    const layer = document.createElement('canvas');
    layer.width = foil.width; layer.height = foil.height;
    const brush = layer.getContext('2d');
    brush.setTransform(dpr, 0, 0, dpr, 0, 0);
    let seed = 842;
    const random = () => { seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0; return seed / 4294967296; };
    const path = [
      [.27,.27,.042], [.20,.68,.047], [.43,.27,.063],
      [.34,.69,.066], [.58,.28,.069], [.48,.71,.068],
      [.72,.36,.064], [.65,.72,.052], [.77,.42,.038], [.75,.82,.028]
    ];
    const markWidth = matchMedia('(min-width:761px)').matches ? .92 : 1;
    brush.fillStyle = brush.strokeStyle = '#63391F';
    brush.lineWidth = W*.027*markWidth; brush.lineCap = 'butt'; brush.lineJoin = 'bevel';
    brush.beginPath();
    path.forEach(([x,y],i) => { if(i)brush.lineTo(x*W,y*H);else brush.moveTo(x*W,y*H); });
    brush.stroke();
    for (let segment = 1; segment < path.length; segment++) {
      const [x1,y1,width1] = path[segment-1], [x2,y2,width2] = path[segment];
      const a = {x:x1*W, y:y1*H}, b = {x:x2*W, y:y2*H};
      const length = Math.hypot(b.x-a.x, b.y-a.y);
      const ux = (b.x-a.x)/length, uy = (b.y-a.y)/length, nx = -uy, ny = ux;
      brush.beginPath();
      for (let side = 0; side < 2; side++) {
        for (let i = 0; i <= 28; i++) {
          const t = side ? 1-i/28 : i/28;
          const half = (width1+(width2-width1)*t)*W*markWidth/2;
          const edge = half*(.91+random()*.18)*(side ? -1 : 1);
          const x = a.x+(b.x-a.x)*t+nx*edge, y = a.y+(b.y-a.y)*t+ny*edge;
          if (!side && !i) brush.moveTo(x,y); else brush.lineTo(x,y);
        }
        const end = side ? a : b;
        const half = (side ? width1 : width2)*W*markWidth/2;
        for (let tooth = 1; tooth < 9; tooth++) {
          const across = half*(1-tooth/4.5)*(side ? -1 : 1);
          const ragged = (random()-.5)*H*.025;
          brush.lineTo(end.x+nx*across+ux*ragged, end.y+ny*across+uy*ragged);
        }
      }
      brush.closePath(); brush.fill();
    }
    brush.globalCompositeOperation = 'destination-out';
    for (let i = 0; i < 2400; i++) {
      brush.globalAlpha = .18+random()*.58;
      const size = W*(.0007+random()*.0023);
      brush.fillRect(W*(.16+random()*.67),H*(.22+random()*.65),size,size*(.5+random()*2));
    }
    ctx.save(); ctx.globalAlpha = .19;
    ctx.drawImage(layer,0,0,W,H); ctx.restore();
  }
  function paintFoil() {
    W = ticket.clientWidth; H = ticket.clientHeight;
    if (!W || !H) { return; }
    dpr = Math.min(window.devicePixelRatio || 1, 3);
    foil.width = W * dpr; foil.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 1;

    var g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, "#D49C74"); g.addColorStop(.38, "#B8704B"); g.addColorStop(.72, "#874A2B"); g.addColorStop(1, "#B06E46");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

    var s = ctx.createLinearGradient(0, 0, W, H * .7);
    s.addColorStop(0, "rgba(255,240,225,0)"); s.addColorStop(.42, "rgba(255,240,225,.22)");
    s.addColorStop(.55, "rgba(255,240,225,.2)"); s.addColorStop(1, "rgba(255,240,225,0)");
    ctx.fillStyle = s; ctx.fillRect(0, 0, W, H);

    ctx.globalAlpha = .11; ctx.fillStyle = noisePattern(); ctx.fillRect(0, 0, W, H); ctx.globalAlpha = 1;

    paintScratchMarks();

    roundRectPath(ctx, 1.5, 1.5, W - 3, H - 3, 16); ctx.lineWidth = 1.5; ctx.strokeStyle = "rgba(250,243,234,.32)"; ctx.stroke();

    var txt = "GRATTEZ ICI", size = Math.round(W * .09), spacing = size * .12;
    ctx.font = "800 " + size + "px AtelierPopupBarlow, 'Helvetica Neue', Arial, sans-serif";
    ctx.textBaseline = "middle"; ctx.textAlign = "left";
    var widths = [], tw = 0;
    for (var i = 0; i < txt.length; i++) { var cw = ctx.measureText(txt[i]).width; widths.push(cw); tw += cw; }
    tw += spacing * (txt.length - 1);
    var x = (W - tw) / 2, y = H / 2;
    ctx.shadowColor = "rgba(40,18,8,.35)"; ctx.shadowBlur = 8; ctx.shadowOffsetY = 2;
    ctx.fillStyle = "rgba(250,243,234,.93)";
    for (var j = 0; j < txt.length; j++) { ctx.fillText(txt[j], x, y); x += widths[j] + spacing; }
    ctx.shadowColor = "transparent"; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;

    cols = Math.ceil(W / CELL); rows = Math.ceil(H / CELL);
    grid = new Uint8Array(cols * rows); marked = 0; total = cols * rows;
  }


  function drawFoil() {
    if (!ctx || !opened || step !== 1 || revealed) return;
    paintFoil();
    if (!W || !H) return;
    replaying = true;
    for (const stroke of strokes) {
      last = stroke.a ? {x:stroke.a.x*W,y:stroke.a.y*H} : null;
      scratchTo(stroke.b.x*W,stroke.b.y*H);
    }
    replaying = false;
    last = null;
  }
  function markCells(x,y) {
    const r=BRUSH,c0=Math.max(0,Math.floor((x-r)/CELL)),c1=Math.min(cols-1,Math.floor((x+r)/CELL));
    const r0=Math.max(0,Math.floor((y-r)/CELL)),r1=Math.min(rows-1,Math.floor((y+r)/CELL));
    for(let cy=r0;cy<=r1;cy++)for(let cx=c0;cx<=c1;cx++) {
      const idx=cy*cols+cx;
      if(grid[idx])continue;
      const dx=cx*CELL+CELL/2-x,dy=cy*CELL+CELL/2-y;
      if(dx*dx+dy*dy<=r*r){grid[idx]=1;marked++;}
    }
  }
  function scratchTo(x,y) {
    if(!ctx || !W || !H)return;
    if(!replaying)strokes.push({a:last?{x:last.x/W,y:last.y/H}:null,b:{x:x/W,y:y/H}});
    ctx.globalCompositeOperation='destination-out';
    ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=BRUSH*2;
    ctx.beginPath();
    if(last){ctx.moveTo(last.x,last.y);ctx.lineTo(x,y);ctx.stroke();}
    else{ctx.arc(x,y,BRUSH,0,Math.PI*2);ctx.fill();}
    const fx=last?last.x:x,fy=last?last.y:y,dist=Math.hypot(x-fx,y-fy),n=Math.max(1,Math.ceil(dist/5));
    for(let i=0;i<=n;i++)markCells(fx+(x-fx)*i/n,fy+(y-fy)*i/n);
    last={x,y};
    if(!replaying && marked/total>=.5)reveal();
  }
  function pointerPos(e){const r=foil.getBoundingClientRect();return{x:e.clientX-r.left,y:e.clientY-r.top};}
  function stop() {
    scratching=false;last=null;
    if(activePointer!==null && foil.hasPointerCapture(activePointer))foil.releasePointerCapture(activePointer);
    activePointer=null;
  }
  foil.addEventListener('pointerdown',e=>{
    if(revealed || activePointer!==null || (e.pointerType==='mouse' && e.button!==0))return;
    e.preventDefault();started=true;scratching=true;last=null;activePointer=e.pointerId;
    foil.setPointerCapture(e.pointerId);
    const p=pointerPos(e);scratchTo(p.x,p.y);
  });
  foil.addEventListener('pointermove',e=>{
    if(!scratching || revealed || e.pointerId!==activePointer)return;
    e.preventDefault();const p=pointerPos(e);scratchTo(p.x,p.y);
  });
  ['pointerup','pointercancel','lostpointercapture'].forEach(name=>foil.addEventListener(name,e=>{if(e.pointerId===activePointer)stop();}));

  function state(){return step===1?(revealed?'reward':'scratch'):step===2?'email':'success';}
  function report(){
    const detail={type:'atelier-popup-state',state:state(),demo:cfg.demo};
    window.dispatchEvent(new CustomEvent('atelier:popup-state',{detail}));
    if(parent!==window && location.protocol!=='file:')parent.postMessage(detail,location.origin);
  }
  function cancelContentTransition(finish=false) {
    const transition = contentTransition;
    if (!transition) return;
    contentTransition = null;
    transition.animations.forEach(animation=>animation.cancel());
    content.inert = false;
    if (finish && !transition.committed) transition.update();
  }
  function changeContent(update, animate=true, outgoing=[content], incoming=[content]) {
    cancelContentTransition(true);
    if (!animate || !opened || matchMedia('(prefers-reduced-motion:reduce)').matches || !content.animate) {
      update(); return;
    }
    const transition = {update, committed:false, animations:[]};
    contentTransition = transition;
    content.inert = true;
    transition.animations = outgoing.map(element=>element.animate([{opacity:1},{opacity:0}],{duration:110,easing:'cubic-bezier(.4,0,1,1)',fill:'both'}));
    Promise.all(transition.animations.map(animation=>animation.finished)).then(() => {
      if (contentTransition !== transition) return;
      transition.committed = true;
      content.inert = false;
      update();
      transition.animations.forEach(animation=>animation.cancel());
      transition.animations = incoming.map(element=>element.animate([{opacity:0},{opacity:1}],{duration:210,easing:'cubic-bezier(.16,1,.3,1)'}));
      return Promise.all(transition.animations.map(animation=>animation.finished));
    }).then(() => {
      if (contentTransition === transition) contentTransition = null;
    }).catch(() => { /* L'annulation lors d'une fermeture ou d'une remise à zéro est normale. */ });
  }
  function reveal(animate=true) {
    if(revealed || step!==1)return;
    revealed=true;stop();
    const focusClaim = document.activeElement===skip;
    foil.classList.add('is-gone');prize.classList.add('is-won');prize.setAttribute('aria-hidden','false');
    changeContent(() => {
      root.classList.add('is-reward');
      claim.hidden=false;skip.hidden=true;rewardHeading.hidden=false;
      [scratchHeading,scratchCopy,hint].forEach(element=>element.setAttribute('aria-hidden','true'));
      live.textContent='Bravo ! Vous avez gagné 10 % de remise. Activez Obtenir ma récompense pour continuer.';
      // Stay on the winning ticket until the explicit CTA is activated.
      if(focusClaim && opened)claim.focus({preventScroll:true});
      report();
    }, animate, [$('#atl-title-1'),scratchCopy,hint], [$('#atl-title-1'),claim]);
  }
  skip.addEventListener('click',()=>reveal());
  claim.addEventListener('click',()=>goStep(2));

  function goStep(n,focus=true) {
    changeContent(() => {
      step=n;
      steps.forEach(s=>s.classList.toggle('is-active',Number(s.dataset.step)===n));
      box.setAttribute('aria-labelledby','atl-title-'+n);
      root.classList.toggle('is-reward',n===1 && revealed);
      panel.scrollTop=0;box.scrollTop=0;
      if(focus && opened)$('#atl-title-'+n).focus({preventScroll:true});
      report();
    }, focus);
  }
  function showError(message) {
    errorEl.textContent=message;errorEl.hidden=!message;
    input.classList.toggle('is-invalid',Boolean(message));
    input.setAttribute('aria-invalid',String(Boolean(message)));
  }
  function success(result) {
    if (!cfg.demo && typeof cfg.onSuccess === 'function') cfg.onSuccess(result);
    const pending=result.status==='pending';
    $('.atl__code').hidden=pending;
    if(pending){
      $('#atl-title-3').innerHTML='Confirmez votre <em>inscription.</em>';
      $('[data-step="3"] .atl__sub').textContent='Cliquez sur le lien reçu par e-mail pour confirmer votre inscription et recevoir votre code.';
    }else{
      codeEl.textContent=result.couponCode;
    }
    input.value='';
    goStep(3);
    live.textContent=pending?'Votre confirmation par e-mail est attendue.':'Votre code de réduction de 10 % est prêt.';
  }
  input.addEventListener('input',()=>showError(''));
  form.addEventListener('submit',async e=>{
    e.preventDefault();if(submitting)return;
    input.value=input.value.trim();
    if(!input.value || !input.validity.valid){showError('Cette adresse ne semble pas valide. Vérifiez-la et réessayez.');input.focus();return;}
    showError('');submitting=true;submit.disabled=true;form.setAttribute('aria-busy','true');submitLabel.textContent='Un instant…';
    const currentGeneration=generation;
    try{
      let result;
      if(cfg.demo){
        await new Promise(resolve=>setTimeout(resolve,500));
        result={status:'subscribed',couponCode:cfg.code};
      }else{
        if(typeof cfg.subscribe!=='function')throw new Error('NOT_CONFIGURED');
        result=await cfg.subscribe({email:input.value,consent:'email_marketing',source:'atelier_scratch_popup_10',consentText:$('#atl-consent').textContent.trim()});
      }
      if(currentGeneration!==generation)return;
      if(!result || !['subscribed','accepted','pending'].includes(result.status))throw new Error('UNCONFIRMED');
      if(['subscribed','accepted'].includes(result.status) && (typeof result.couponCode!=='string' || !result.couponCode.trim()))throw new Error('NO_COUPON');
      success(result);
    }catch(err){
      console.warn('[Atelier inscription]', err?.name, err?.message);
      if(currentGeneration!==generation)return;
      showError(err?.message==='NOT_CONFIGURED'?'L’inscription n’est pas encore disponible. Merci de réessayer plus tard.':"Nous n'avons pas pu enregistrer votre adresse. Réessayez dans un instant.");
      live.textContent=errorEl.textContent;
    }finally{
      if(currentGeneration===generation){submitting=false;submit.disabled=false;form.removeAttribute('aria-busy');submitLabel.textContent='Obtenir ma réduction';}
    }
  });
  copyBtn.addEventListener('click',async()=>{
    try{
      if(!navigator.clipboard?.writeText)throw new Error('CLIPBOARD_UNAVAILABLE');
      await navigator.clipboard.writeText(codeEl.textContent);
      copyBtn.textContent='Copié !';live.textContent='Code copié.';
    }catch{
      const range=document.createRange();range.selectNodeContents(codeEl);
      const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);
      copyBtn.textContent='Sélectionné';live.textContent='Code sélectionné. Utilisez Copier sur votre appareil.';
    }
    clearTimeout(copyTimer);copyTimer=setTimeout(()=>copyBtn.textContent='Copier',2200);
  });

  function isolatePage(){
    isolated=[];
    for(let branch=root;branch.parentElement;branch=branch.parentElement){
      for(const sibling of branch.parentElement.children){
        if(sibling===branch || ['SCRIPT','STYLE','LINK'].includes(sibling.tagName))continue;
        isolated.push({element:sibling,inert:sibling.inert});sibling.inert=true;
      }
      if(branch.parentElement===document.body)break;
    }
  }
  function lockPage(){
    scrollX=window.scrollX;scrollY=window.scrollY;
    const body=document.body;
    savedBody={};
    for(const prop of ['position','top','left','width','overflow'])savedBody[prop]=body.style[prop];
    body.style.position='fixed';body.style.top=-scrollY+'px';body.style.left=-scrollX+'px';body.style.width='100%';body.style.overflow='hidden';
    hadLock=document.documentElement.classList.contains('atl-lock');document.documentElement.classList.add('atl-lock');
  }
  function unlockPage(){
    if(savedBody)for(const [prop,value] of Object.entries(savedBody))document.body.style[prop]=value;
    if(!hadLock)document.documentElement.classList.remove('atl-lock');
    isolated.forEach(({element,inert})=>element.inert=inert);isolated=[];
    const html=document.documentElement,behavior=html.style.scrollBehavior;
    html.style.scrollBehavior='auto';window.scrollTo(scrollX,scrollY);html.style.scrollBehavior=behavior;
  }
  function open(){
    if(opened || !root.isConnected)return;
    clearTimeout(closeTimer);
    if(finishClose){finishClose();finishClose=null;}
    lastFocus=document.activeElement;opened=true;
    lockPage();isolatePage();
    root.classList.remove('is-closing');root.hidden=false;root.setAttribute('aria-hidden','false');
    drawFoil();box.focus({preventScroll:true});report();
    openFrame=requestAnimationFrame(()=>{
      openFrame=requestAnimationFrame(()=>{if(opened)root.classList.add('is-open');});
    });
  }
  function close(){
    if(!opened)return;
    stop();opened=false;cancelAnimationFrame(openFrame);cancelContentTransition(true);
    root.classList.add('is-closing');root.classList.remove('is-open');
    finishClose=()=>{
      root.hidden=true;root.setAttribute('aria-hidden','true');root.classList.remove('is-closing');
      unlockPage();
    if (!cfg.demo && typeof cfg.onClose === 'function') cfg.onClose();
      if(lastFocus?.isConnected && lastFocus!==document.body && !root.contains(lastFocus))lastFocus.focus({preventScroll:true});
    };
    closeTimer=setTimeout(()=>{finishClose?.();finishClose=null;},matchMedia('(prefers-reduced-motion:reduce)').matches?0:320);
  }
  function reset(){
    cancelContentTransition();generation++;stop();clearTimeout(copyTimer);
    started=false;revealed=false;strokes=[];last=null;submitting=false;
    foil.classList.remove('is-gone');prize.classList.remove('is-won');prize.setAttribute('aria-hidden','true');
    root.classList.remove('is-reward');claim.hidden=true;hint.hidden=false;skip.hidden=false;
    scratchHeading.hidden=false;rewardHeading.hidden=true;scratchCopy.hidden=false;
    [scratchHeading,scratchCopy,hint].forEach(element=>element.removeAttribute('aria-hidden'));
    form.reset();showError('');submit.disabled=false;submitLabel.textContent='Obtenir ma réduction';form.removeAttribute('aria-busy');
    copyBtn.textContent='Copier';codeEl.textContent=cfg.code;$('.atl__code').hidden=false;
    $('#atl-title-3').innerHTML='Votre code est <em>prêt.</em>';
    $('[data-step="3"] .atl__sub').innerHTML="Il s'applique à votre première commande. Nous vous l'envoyons aussi par <span class=\"atl__nw\">e-mail</span>.";
    live.textContent='';goStep(1,false);drawFoil();
  }
  function previewStep(next){
    if(!cfg.demo)return;
    reset();open();
    if(next==='reward')reveal(false);
    if(next==='email')goStep(2,false);
    if(next==='success'){success({status:'subscribed',couponCode:cfg.code});}
    report();
  }
  root.querySelectorAll('[data-atl-close]').forEach(el=>el.addEventListener('click',close));
  root.addEventListener('keydown',e=>{
    if(!opened || !root.isConnected)return;
    if(e.key==='Escape'){e.preventDefault();close();return;}
    if(e.key!=='Tab')return;
    const nodes=[...box.querySelectorAll('button,a[href],input,[tabindex]')].filter(el=>!el.disabled && !el.closest('[inert]') && el.tabIndex>=0 && el.getClientRects().length);
    const first=nodes[0],lastNode=nodes[nodes.length-1],active=document.activeElement;
    if(!first){e.preventDefault();return;}
    if(e.shiftKey && (active===first || !nodes.includes(active))){e.preventDefault();lastNode.focus();}
    else if(!e.shiftKey && (active===lastNode || !nodes.includes(active))){e.preventDefault();first.focus();}
  });
  new ResizeObserver(()=>{if(opened && !revealed)drawFoil();}).observe(ticket);
  document.fonts.ready.then(()=>{if(!started)drawFoil();});
  window.atelierPopup=Object.freeze({open,close,replay:()=>{reset();open();},previewStep});
  window.AtelierScratchPopup=window.atelierPopup;
  window.addEventListener('message',event=>{
    if(event.source!==parent || event.origin!==location.origin || !cfg.demo)return;
    if(event.data?.type==='atelier-popup-preview')previewStep(event.data.step);
  });
  if(cfg.autoOpen)open();
  const requestedStep=new URLSearchParams(location.search).get('etape');
  if(cfg.demo && requestedStep)previewStep(requestedStep);
  report();
})();
